import React, { Component } from 'react';
import DateTime from 'react-datetime';

import './../../../node_modules/react-datetime/css/react-datetime.css';

class CarForm extends Component
{
    constructor(props)
    {
        super(props);

        this.onChange = props.onChange;
        
        this.handeInput = this.handeInput.bind(this);
        this.handleDate = this.handleDate.bind(this);

        this.DateTimeCode = React.createRef();
        this.DateTimeBegin = React.createRef();
        this.DateTimeEnd = React.createRef();
        this.DateTimeDelivery = React.createRef();
        this.DateTimeStartDiac = React.createRef();
        this.DateTimeEndDiac = React.createRef();
        this.DateTimeOrder = React.createRef();
        this.DateTimeStartCtSce = React.createRef();
        this.DateTimeEngraving = React.createRef();
    }

    handeInput(event)
    {
        let value = event.target.type === 'checkbox' ? (event.target.checked === true ? 1 : 0) : event.target.value;
        let evt = {
            "target" : {
                "name" : event.target.name,
                "value" : value
            } 
        }
        
        this.onChange(evt);
    }

    handleDate(ref, name, date)
    {
        ref.current.querySelector('.text-danger').style.display = "none";
        ref.current.querySelector('.rdt .form-control').classList.remove("invalid")
        if(date._isAMomentObject == null)
        {
            ref.current.querySelector('.text-danger').style.display = "initial";
            ref.current.querySelector('.rdt .form-control').classList.add("invalid");
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : null
                } 
            }
            this.onChange(evt);
            return;
        }
        else
        {
            let evt = {
                "target" : {
                    "name" : name,
                    "value" : date.unix()
                } 
            }
            this.onChange(evt);
        }
    }

    render()
    {
        return (
            <form>
                <div className="row">
                    <div className="col">
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Marque
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="brand" value={ this.props.car.brand } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Modèle
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="model" value={ this.props.car.model } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                VIN
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="vin" value={ this.props.car.vin } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group" ref={ this.DateTimeCode }>
                            <label className="h5 font-weight-bold">
                                Date de 1ère immatriculation
                            </label>
                            <DateTime name="date" timeFormat={ false } locale="fr" onChange={ (date) => { this.handleDate(this.DateTimeCode, "date_first_code", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_first_code != null ? this.props.car.date_first_code*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Immatriculation
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="code" value={ this.props.car.code } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>
                
                        <div className="form-group" ref={ this.DateTimeBegin }>
                            <label className="h5 font-weight-bold">
                                Date début relation MAEVA
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeBegin, "date_begin", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_begin != null ? this.props.car.date_begin*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group" ref={ this.DateTimeEnd }>
                            <label className="h5 font-weight-bold">
                                Date fin relation MAEVA
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeEnd, "date_end", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_end != null ? this.props.car.date_end*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group" ref={ this.DateTimeDelivery }>
                            <label className="h5 font-weight-bold">
                                Date de livraison véhicule
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeDelivery, "date_delivery", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_delivery != null ? this.props.car.date_delivery*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Contrat
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="contract" value={ this.props.car.contract } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Financement
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="finance" value={ this.props.car.finance } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Assurance
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="insurance" value={ this.props.car.insurance } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Kilométrage
                            </label>
                            <input type="number" min="0" className="form-control" name="km" value={ this.props.car.km } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>
                    </div>

                    <div className="col">
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                            Usage du véhicule
                            </label>
                            <select className="form-control" name="use" value={ this.props.car.use } onChange={ this.handeInput }>
                                <option disabled selected value=""> -- Choisissez un usage -- </option>
                                <option value="Professionnel">Professionnel</option>
                                <option value="Personnel">Personnel</option>
                                <option value="Familial">Familial</option>
                                <option value="Mixte">Mixte</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold"> 
                                Véhicule de remplacement
                            </label>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="replacement_interested" checked={ this.props.car.replacement_interested == 1 } onClick={ this.handeInput } id="replacementInterested" />
                                <label className="form-check-label" htmlFor="replacementInterested">
                                    Intéressé
                                </label>
                            </div>
                            { 
                                this.props.car.replacement_interested == 1 &&
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" name="replacement_same" checked={ this.props.car.replacement_same == 1 } onClick={ this.handeInput } id="replacementSame" />
                                    <label className="form-check-label" htmlFor="replacementSame">
                                        Type identique
                                    </label>
                                </div>
                            }
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold"> 
                                Lieu d'achat
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="place_purchase" value={ this.props.car.place_purchase } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une adresse valide de moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold"> 
                                Utilisateur principal
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="main_user" value={ this.props.car.main_user } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une nom de moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold"> 
                                Payeur/Financeur
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="payer" value={ this.props.car.payer } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une nom de moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold"> 
                                Décisionnaire d'achat 
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="decision_maker" value={ this.props.car.decision_maker } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une nom de moins de 100 caractères.
                            </small>
                        </div>

                        {/* Lien entre chaque Utilisateur de véhicule */}

                        <div className="form-group">
                            <label className="h5 font-weight-bold"> 
                                Mode de financement
                            </label>
                            <select className="form-control" name="funding" value={ this.props.car.funding } onChange={ this.handeInput }>
                                <option disabled selected value=""> -- Choisissez un mode de financement -- </option>
                                <option value="Comptant">Comptant</option>
                                <option value="Crédit classique">Crédit classique</option>
                                <option value="Location">Location</option>
                            </select>
                        </div> 

                        {
                            this.props.car.funding == "Location" &&
                            <div className="form-group">
                                <label className="h5 font-weight-bold">
                                    Kilométrage moyen annuel 
                                </label>
                                <input type="number" min="0" max="999 999" className="form-control" name="avg_km" value={ this.props.car.avg_km } onChange={ this.handeInput } />
                                <small className="text-danger form-text">
                                    Ce champ doit contenir un nombre entier entre 0 et 999 999.
                                </small>
                            </div>
                        }
                        {
                            this.props.car.funding == "Location" &&
                            <div className="form-group">
                                <label className="h5 font-weight-bold">
                                    Durée de la location (en mois)
                                </label>
                                <input type="number" min="0" max="999" className="form-control" name="duration" value={ this.props.car.duration } onChange={ this.handeInput } />
                                <small className="text-danger form-text">
                                    Ce champ doit contenir un nombre entier entre 0 et 999.
                                </small>
                            </div>
                        }
                        
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Budget annuel accordé
                            </label>
                            <input type="number" min="0" max="99 999" className="form-control" name="budget" value={ this.props.car.budget } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier entre 0 et 99 999.
                            </small>
                        </div>

                        <div className="form-group" ref={ this.DateTimeEngraving}>
                            <label className="h5 font-weight-bold">
                                Date gravage
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeEngraving, "date_engraving", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_engraving != null ? this.props.car.date_engraving*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Gravage
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="engraving" value={ this.props.car.engraving } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                    </div>

                    <div className="col">
                        <div className="form-group" ref={ this.DateTimeOrder}>
                            <label className="h5 font-weight-bold">
                                Date commande DCSnet
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeOrder, "date_order", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_order != null ? this.props.car.date_order*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Concession commande
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="shortname" value={ this.props.car.shortname } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Vendeur commande
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="conseilor" value={ this.props.car.conseilor } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Agent
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="agent" value={ this.props.car.agent } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group" ref={ this.DateTimeStartDiac}>
                            <label className="h5 font-weight-bold">
                                Date d'entrée en gestion DIAC
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeStartDiac, "date_start_diac", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_start_diac != null ? this.props.car.date_start_diac*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group" ref={ this.DateTimeEndDiac}>
                            <label className="h5 font-weight-bold">
                                Date de fin de contrat REELLE DIAC
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeEndDiac, "date_end_diac", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_end_diac != null ? this.props.car.date_end_diac*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Numéro de contrat DIAC
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="diac_contract_number" value={ this.props.car.diac_contract_number } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Produit Financier DIAC
                            </label>
                            <select className="form-control" name="diac_financial_product" value={ this.props.car.diac_financial_product } onChange={ this.handeInput }>
                                <option disabled selected value=""> -- Choisissez un produit financier -- </option>
                                <option value="CB">CB</option>
                                <option value="CC">CC</option>
                                <option value="DL">DL</option>
                                <option value="LL">LL</option>
                                <option value="LP">LP</option>
                                <option value="OV">OV</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Marché DIAC
                            </label>
                            <select className="form-control" name="diac_market" value={ this.props.car.diac_market } onChange={ this.handeInput }>
                                <option disabled selected value=""> -- Choisissez un marché -- </option>
                                <option value="ENTREPRISES">ENTREPRISES</option>
                                <option value="LOUEURS">LOUEURS</option>
                                <option value="PARTICULIERS">PARTICULIERS</option>
                                <option value="PGR">PGR</option>
                                <option value="RESEAU">RESEAU</option>
                            </select>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Offre commerciale DIAC
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="diac_commercial_offer" value={ this.props.car.diac_commercial_offer } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Durée DIAC
                            </label>
                            <input type="number" min="0" max="999" className="form-control" name="diac_duration" value={ this.props.car.diac_duration } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier entre 0 et 999.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Prestations assurances DIAC
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="diac_insurance" value={ this.props.car.diac_insurance } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Nombre d'assurances DIAC
                            </label>
                            <input type="number" min="0" className="form-control" name="diac_insurance_number" value={ this.props.car.diac_insurance_number } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier positif.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Nb EGVO DIAC
                            </label>
                            <input type="number" min="0" className="form-control" name="diac_egvo_number" value={ this.props.car.diac_egvo_number } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier positif.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Prix de Vente DIAC
                            </label>
                            <input type="number" min="0" className="form-control" name="diac_selling_price" value={ this.props.car.diac_selling_price } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier positif.
                            </small>
                        </div>
                        
                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                CA DIAC
                            </label>
                            <input type="number" min="0" className="form-control" name="diac_ca" value={ this.props.car.diac_ca } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier positif.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                ER DIAC
                            </label>
                            <input type="number" min="0" className="form-control" name="diac_er" value={ this.props.car.diac_er } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier positif.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Barême assurable DIAC
                            </label>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" name="diac_insurable" checked={ this.props.car.diac_insurable == 1 } onClick={ this.handeInput } id="diac_insurable" />
                                <label className="form-check-label" htmlFor="diac_insurable">
                                    Barême assurable
                                </label>
                            </div>
                        </div>

                        <div className="form-group" ref={ this.DateTimeStartCtSce }>
                            <label className="h5 font-weight-bold">
                                Date de début de contrat CtSce
                            </label>
                            <DateTime name="date" timeFormat={ false } onChange={ (date) => { this.handleDate(this.DateTimeStartCtSce, "date_start_ctsce", date)  } } dateFormat="DD/MM/YYYY" value={ this.props.car.date_start_ctsce != null ? this.props.car.date_start_ctsce*1000 : null } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir une date valide
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                N° de contrat CtSce
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="contract_number_ctsce" value={ this.props.car.contract_number_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Code barème CtSce
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="scale_code_ctsce" value={ this.props.car.scale_code_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Classe entretien CtSce
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="maintenance_class_ctsce" value={ this.props.car.maintenance_class_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Code famille produit CtSce
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="product_family_ctsce" value={ this.props.car.product_family_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Durée souscrite CtSce
                            </label>
                            <input type="number" min="0" max="999" className="form-control" name="duration_ctsce" value={ this.props.car.duration_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier entre 0 et 999.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Km souscrit CtSce
                            </label>
                            <input type="number" min="0" max="999 999" className="form-control" name="km_ctsce" value={ this.props.car.km_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir un nombre entier entre 0 et 999 999.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Nom fournisseur CtSce
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="supplier_ctsce" value={ this.props.car.supplier_ctsce } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Type Marché CtSce
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="market_type_ctse" value={ this.props.car.market_type_ctse } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                        <div className="form-group">
                            <label className="h5 font-weight-bold">
                                Produit détaillé
                            </label>
                            <input type="text" maxLength="100" className="form-control" name="product_detail" value={ this.props.car.product_detail } onChange={ this.handeInput } />
                            <small className="text-danger form-text">
                                Ce champ doit contenir moins de 100 caractères.
                            </small>
                        </div>

                    </div>
                </div>

            </form>
        );
    }
}

export default CarForm;



// WEBPACK FOOTER //
// ./src/Components/Car/CarForm.js